var map = {
	"./adalliance.png": 8707,
	"./gauge.png": 3242,
	"./gaugeSharp.png": 5784,
	"./laptop.png": 5239,
	"./logo.png": 2806,
	"./logout.png": 4425,
	"./menu.svg": 4618,
	"./youtube.png": 2616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;